import { useMemo, useState } from 'react';
import zhConvertor from 'zhconvertor';
import CandidateIcons from '../SeatDetail/CandidateIcons';
import { getBgColorByParty } from '../SeatDetail/seatHelpers';
import './VoteUpdates.css';

const tr = (text) =>
  localStorage.getItem('lang') !== 'zh_TW' ? zhConvertor.t2s(text) : text;

// Latest vote updates (最新战况): seats ordered by their votes' last update
// time, each row showing the currently leading candidate. Renders nothing
// until at least one seat has an update, and disappears once every seat's
// result is official. `data` is a seatinfo API array; `onSeatClick(seatname)`
// is fired when a row is clicked. Hosts reset the paging by remounting (key).
const VoteUpdates = ({ data, onSeatClick }) => {
  // How many lines are visible; "view more" adds 10.
  const [updatesShown, setUpdatesShown] = useState(5);

  // Seats with at least one vote update and a leader with actual votes
  // (a 0-vote "leader" is noise), newest first.
  const voteUpdates = useMemo(
    () =>
      (data || [])
        .filter(
          (s) =>
            Number(s.last_upd) > 0 &&
            (s.candidate || []).some((c) => Number(c.votes) > 0)
        )
        .sort((a, b) => Number(b.last_upd) - Number(a.last_upd)),
    [data]
  );
  const allOfficial =
    (data || []).length > 0 && data.every((s) => Number(s.is_o) === 1);

  if (allOfficial || voteUpdates.length === 0) return null;

  return (
    <div className="vote_updates">
      <h3>
        <span className="vu-live-dot" />
        {tr('最新战况')}
      </h3>
      <ul className="vote_updates__list">
        {voteUpdates.slice(0, updatesShown).map((seat) => {
          const leader = [...(seat.candidate || [])].sort(
            (a, b) => (b.votes || 0) - (a.votes || 0)
          )[0];
          if (!leader) return null;
          return (
            <li key={seat.seatname}>
              <button
                type="button"
                className="vote_updates__row"
                style={{ borderLeftColor: getBgColorByParty(leader.alliance_en) }}
                onClick={() => onSeatClick(seat.seatname)}
              >
                <span className="vu-seat">
                  {seat.seatname} {tr(seat.ednamec)}
                </span>
                <span className="vu-icon">
                  <CandidateIcons candidate={leader} />
                </span>
                <span className="vu-party">
                  {leader.party} {leader.alliance && `(${leader.alliance})`}
                </span>
                <span className="vu-photo">
                  {leader.candidate_logo && (
                    <img
                      className="cand-photo"
                      src={leader.candidate_logo}
                      alt=""
                      onError={(e) => {
                        e.currentTarget.style.display = 'none';
                      }}
                    />
                  )}
                </span>
                <span className="vu-name">{tr(leader.candidate_name)}</span>
                <span className="vu-votes">
                  {tr('以')}{' '}
                  <strong>{Number(leader.votes || 0).toLocaleString()}</strong>
                  {tr('张票 暂时领先')}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
      {updatesShown < voteUpdates.length && (
        <div className="vote_updates__more">
          <button
            type="button"
            className="btn-secondary"
            onClick={() => setUpdatesShown((n) => n + 10)}
          >
            {tr('查看更多')}
          </button>
        </div>
      )}
    </div>
  );
};

export default VoteUpdates;
